import { ItemConnectionSort } from '../../graphql/types';

import { PriceViewMode } from '../../components/GeneralAdsPage/types';

import { BUILDING_TYPE_ID } from './constants';

type SortMapping = Record<
  PriceViewMode,
  Partial<Record<ItemConnectionSort, ItemConnectionSort>>
>;

export const CATEGORY_SORT_NORMALIZATION: Record<
  string | 'DEFAULT',
  Partial<Record<ItemConnectionSort, ItemConnectionSort>>
> = {
  [BUILDING_TYPE_ID.AREA]: {},
  DEFAULT: {
    [ItemConnectionSort.PricePerAreAsc]: ItemConnectionSort.PriceAsc,
    [ItemConnectionSort.PricePerAreDesc]: ItemConnectionSort.PriceDesc
  }
};

export function normalizeSortByCategory(
  categoryId?: number | string,
  sort?: ItemConnectionSort
): ItemConnectionSort | undefined {
  const mapping =
    CATEGORY_SORT_NORMALIZATION[String(categoryId)] ??
    CATEGORY_SORT_NORMALIZATION.DEFAULT;

  return mapping[sort as ItemConnectionSort] ?? sort;
}

export const SORT_MAPPINGS: SortMapping = {
  [PriceViewMode.PerArea]: {
    [ItemConnectionSort.PricePerAreAsc]: ItemConnectionSort.PriceAsc,
    [ItemConnectionSort.PricePerAreDesc]: ItemConnectionSort.PriceDesc
  },
  [PriceViewMode.PerAcre]: {
    [ItemConnectionSort.PriceAsc]: ItemConnectionSort.PricePerAreAsc,
    [ItemConnectionSort.PriceDesc]: ItemConnectionSort.PricePerAreDesc
  }
};

export function normalizeSort(
  priceMode: PriceViewMode,
  sort: ItemConnectionSort
): ItemConnectionSort {
  return SORT_MAPPINGS[priceMode][sort] ?? sort;
}

const DENORMALIZE_SORT_MAP: Partial<
  Record<ItemConnectionSort, ItemConnectionSort>
> = {
  [ItemConnectionSort.PricePerAreAsc]: ItemConnectionSort.PriceAsc,
  [ItemConnectionSort.PricePerAreDesc]: ItemConnectionSort.PriceDesc
};

export function denormalizeSort(sort: ItemConnectionSort): ItemConnectionSort {
  return DENORMALIZE_SORT_MAP[sort] ?? sort;
}
